import { CDN_IMG_URL } from "@casino/legacy/shared/cdn/url";

const getProviderIcon = (handle: string) =>
  `${CDN_IMG_URL}/providers/small-icons/${handle}.svg`;

export default getProviderIcon;
